<template>
  <div>
    <v-list-tile-action>
      <v-icon v-if="seen_at == null" color="#211850">pending</v-icon>
      <v-icon v-else color="#638d37">done_all</v-icon>
    </v-list-tile-action>
  </div>
</template>

<script>
import axios from "axios";

  export default {
    props: {
      seen_at: {
        required: true
      }
    },
    data () {
      return {

      }
    },
  }
</script>

